import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "../actions";
import ApplicationForm from "../components/applicationForm/applicationForm";
import {
  AUTHORIZATION_CODE,
  CLIENT_CREDENTIALS,
} from "../constants/application";
import Breadcrumb from "../components/breadcrumb/breadcrumb";
import withTracker from "./withtracker";
import AuthorizationHOC from "./AuthorizationHOC";
import { REGISTERED_USERS } from "../constants/userGroups";
import withBreadCrumb from "./withBreadcrumb";
import { getRouteUrl } from "../routers";
import SectionStart from "../components/sectionStart/sectionStart";
import {
  Sidebar,
  SidebarHeader,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../components/layouts/layout1";
import Title from "../components/title/title";
import Heading from "../components/heading/heading";
import BracketButton from "../components/bracketButton/bracketButton";
import { ROUTE_ORGANIZATION_VIEW_SINGLE } from "../routers/content/organization";
import queryString from "query-string";
import { parseOrganization } from "../constants/parse/organization";

const parseTags = (tags) => {
  if (!tags) return [];
  if (Array.isArray(tags)) return tags;
  if (typeof tags === "object") return Object.values(tags);
  return [];
};

function ApplicationCreateHOC(props) {
  const {
    breadcrumb,
    loading,
    errorMessage,
    applicationForm,
    updateOAuthTag,
    updatePostLogoutTag,
    editApplication,
    createApplication,
    clearFormState,
  } = props;

  const { organizations, location } = props;
  const { organization } = queryString.parse(location.search);

  const handleSubmit = (values) => {
    createApplication({
      title: values.title,
      description: values.description,
      allowedGrantTypes: createGrantTypes(
        values.authorizationCodeAllowed,
        values.clientCredentialsAllowed
      ),
      oAuthRedirectUri: values.oAuthRedirectUri,
      postLogoutRedirectUri: values.postLogoutRedirectUri,
      organizationId: organization,
    });
  };

  useEffect(() => {
    clearFormState();
  }, []);

  useEffect(() => {
    if (!organizations || !organizations[organization]) {
      props.fetchOrganizations({
        uuid: organization,
      });
    }
  }, [organization]);

  const organizationData = parseOrganization(
    props.organizations && props.organizations[organization]
  );

  // Prepare initial values for Formik - empty for create
  const initialValues = {
    title: "",
    description: "",
    authorizationCodeAllowed: false,
    clientCredentialsAllowed: false,
    applicationUuid: "",
    subscriptionIds: [],
  };

  return (
    <div>
      {organizationData && (
        <Breadcrumb
          {...breadcrumb}
          params={{
            org: {
              href: getRouteUrl(ROUTE_ORGANIZATION_VIEW_SINGLE, {
                organizationId: organization,
              }),
              name: organizationData.title,
            },
          }}
        />
      )}
      <SectionStart>
        <SideBar>
          <SidebarLeft>
            {" "}
            <SidebarHeader>
              <Title type="section">
                <Heading level="1" className="display-effect">
                  New application
                </Heading>
              </Title>
              <BracketButton
                caretEnable
                className="movingBrackets left"
                title={"BACK TO OVERVIEW"}
                url={getRouteUrl(ROUTE_ORGANIZATION_VIEW_SINGLE, {
                  organizationId: organization,
                })}
              />
            </SidebarHeader>
          </SidebarLeft>
          <SidebarRight>
            <ApplicationForm
              createApplication={handleSubmit}
              editApplication={editApplication}
              loading={loading}
              errorMessage={errorMessage}
              oAuthTagsValue={parseTags(applicationForm?.oAuthRedirectUri)}
              oAuthTagsUpdate={updateOAuthTag}
              postLogoutTagsValue={parseTags(
                applicationForm?.postLogoutRedirectUri
              )}
              postLogoutUpdate={updatePostLogoutTag}
              initialValues={initialValues}
            />
          </SidebarRight>
        </SideBar>
      </SectionStart>
    </div>
  );
}

const mapStateToProps = (state) => ({
  organizations: state.organizationReducer?.byId,
  loading: state.application?.loading,
  errorMessage: state.application?.errorMessage,
  applicationForm: state.applicationForm,
});

const createGrantTypes = (auth, credentials) => {
  const grantTypes = [];
  if (auth) grantTypes.push(AUTHORIZATION_CODE);
  if (credentials) grantTypes.push(CLIENT_CREDENTIALS);
  return grantTypes;
};

const mapDispatchToProps = (dispatch) => ({
  createApplication: (payload) => {
    dispatch(actions.createApplication(payload));
  },
  fetchOrganizations: (payload) => {
    dispatch(actions.fetchOrganizations(payload));
  },
  editApplication: (payload) => {
    dispatch(
      actions.editApplication({
        applicationUuid: payload?.applicationUuid,
        title: payload?.title,
        description: payload?.description,
        allowedGrantTypes: createGrantTypes(
          payload?.authorizationCodeAllowed,
          payload?.clientCredentialsAllowed
        ),
        oAuthRedirectUri: payload?.oAuthRedirectUri,
        postLogoutRedirectUri: payload?.postLogoutRedirectUri,
        organizationId: payload?.organizationId,
        subscriptionIds: payload?.subscriptionIds,
      })
    );
  },
  updateOAuthTag: (payload) => {
    dispatch(actions.updateOAuthTag(payload));
  },
  updatePostLogoutTag: (payload) => {
    dispatch(actions.updatePostLogoutTag(payload));
  },
  clearFormState: () => {
    dispatch(actions.clearStateAfterCreatingApplication());
  },
});

export default withTracker(
  AuthorizationHOC(REGISTERED_USERS)(
    withBreadCrumb(
      connect(mapStateToProps, mapDispatchToProps)(ApplicationCreateHOC),
      {
        name: "New",
        parents: ["Organizations", "{org}"],
      }
    )
  )
);
